// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesSingleInstanceStatus
 */
export interface TypesSingleInstanceStatus {
  /**
   *
   * @type {number}
   * @memberof TypesSingleInstanceStatus
   */
  desiredPods?: number;
  /**
   *
   * @type {number}
   * @memberof TypesSingleInstanceStatus
   */
  podsWithBoltAvailable?: number;
  /**
   *
   * @type {number}
   * @memberof TypesSingleInstanceStatus
   */
  runningPods?: number;
  /**
   *
   * @type {number}
   * @memberof TypesSingleInstanceStatus
   */
  updatedPods?: number;
}

/**
 * Check if a given object implements the TypesSingleInstanceStatus interface.
 */
export function instanceOfTypesSingleInstanceStatus(
  value: object,
): value is TypesSingleInstanceStatus {
  return true;
}

export function TypesSingleInstanceStatusFromJSON(
  json: any,
): TypesSingleInstanceStatus {
  return TypesSingleInstanceStatusFromJSONTyped(json, false);
}

export function TypesSingleInstanceStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesSingleInstanceStatus {
  if (json == null) {
    return json;
  }
  return {
    desiredPods: json['DesiredPods'] == null ? undefined : json['DesiredPods'],
    podsWithBoltAvailable:
      json['PodsWithBoltAvailable'] == null
        ? undefined
        : json['PodsWithBoltAvailable'],
    runningPods: json['RunningPods'] == null ? undefined : json['RunningPods'],
    updatedPods: json['UpdatedPods'] == null ? undefined : json['UpdatedPods'],
  };
}

export function TypesSingleInstanceStatusToJSON(
  json: any,
): TypesSingleInstanceStatus {
  return TypesSingleInstanceStatusToJSONTyped(json, false);
}

export function TypesSingleInstanceStatusToJSONTyped(
  value?: TypesSingleInstanceStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    DesiredPods: value['desiredPods'],
    PodsWithBoltAvailable: value['podsWithBoltAvailable'],
    RunningPods: value['runningPods'],
    UpdatedPods: value['updatedPods'],
  };
}
